import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ChatboxserviceService {

  private selfId = localStorage.getItem('userId');
  private role = localStorage.getItem('userFlag'); // doctor / patient

  constructor(private afs: AngularFirestore) {}

  async joinRoom(roomId: string) {
    const ref = this.afs.collection('rooms').doc(roomId);
    const snap = await ref.get().toPromise();

    if (!snap.exists) {
      await ref.set({
        created: Date.now()
      });
    }
  }

  sendMessage(roomId: string, text: string) {
    return this.afs.collection('rooms')
      .doc(roomId)
      .collection('messages')
      .add({
        from: this.selfId,
        role: this.role,
        text: text?.trim(),
        time: Date.now(),
        read: false
      });
  }

  listen(roomId: string) {
    return this.afs.collection('rooms')
      .doc(roomId)
      .collection('messages', ref => ref.orderBy('time'))
      .valueChanges()
      .pipe(
        map((msgs: any[]) =>
          msgs.map(m => ({
            ...m,
            isMine: m.from === this.selfId
          }))
        )
      );
  }
}
